import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { globalState, baseUrl, accessTokenKey, contact, siteName } from "../../utils/config";
import imagePlaceholder from "../../assets/img/user-placeholder.png";

function Footer() {

    const [state, setState] = useState(globalState.state);

    async function toggleChat(id) {
        const box = document.getElementById("chat" + id);
        box.classList.toggle("open");

        if (box.classList.contains("open")) {
            const chats = [ ...state.chats ];
            for (let a = 0; a < chats.length; a++) {
                if (chats[a].id == id && !chats[a].hasFetchedMessages) {
                    chats[a].fetching = true;
                    try {
                        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        const formData = new FormData();
                        formData.append("user_id", chats[a].id);
                        formData.append("page", chats[a].page);
                        formData.append("time_zone", timeZone);

                        globalState.setState({
                            chats: chats
                        });

                        const response = await axios.post(
                            baseUrl + "/api/messages/fetch",
                            formData,
                            {
                                headers: {
                                    Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                                }
                            }
                        );

                        if (response.data.status == "success") {
                            const messages = response.data.messages;
                            
                            chats[a].messages = messages.reverse();
                        } else {
                            swal.fire("Error", response.data.message, "error");
                        }
                    } catch (exp) {
                        console.log(exp.message);
                    } finally {
                        chats[a].fetching = false;
                        chats[a].hasFetchedMessages = true;

                        globalState.setState({
                            chats: chats
                        });
                    }
                }
            }
        }
    }

    function closeChat(id) {
        const chats = [ ...state.chats ];
        for (let a = 0; a < chats.length; a++) {
            if (chats[a].id == id) {
                chats.splice(a, 1);
                break;
            }
        }
        globalState.setState({
            chats: chats
        });
    }

    async function handleSend(event, chat) {
        if (event.key === 'Enter') {
            const input = event.target;
            const text = input.value.trim();
            if (!text) return;

            input.value = '';

            try {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const formData = new FormData();
                formData.append("user_id", chat.id);
                formData.append("message", text);
                formData.append("time_zone", timeZone);

                const response = await axios.post(
                    baseUrl + "/api/messages/send",
                    formData,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                        }
                    }
                );

                if (response.data.status == "success") {
                    const message = response.data.message_obj;
                    const chats = [ ...state.chats ];
                    for (let a = 0; a < chats.length; a++) {
                        if (chats[a].id == chat.id) {
                            chats[a].messages.push(message);
                            break;
                        }
                    }
                    globalState.setState({
                        chats: chats
                    });
                } else {
                    swal.fire("Error", response.data.message, "error");
                    input.value = text;
                }
            } catch (exp) {
                console.log(exp.message);
                input.value = text;
            }
        }
    }

    useEffect(function () {
        globalState.listen(function (newState, updatedState) {
            setState(newState);

            // if (typeof updatedState.chats !== "undefined" && updatedState.chats.length > 0) {
            //     console.log(updatedState.chats);
            // }
        });
    }, []);

    const styles = {
        profileImage: {
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
            marginRight: "10px"
        }
    };

    return (
        <>
            <div className="container-fluid bg-dark text-white-50 footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white mb-4">Quick Links</h5>
                            <Link className="btn btn-link text-white-50" to="/about">About</Link>
                            <Link className="btn btn-link text-white-50" to="/notifications">Notifications</Link>
                            <Link className="btn btn-link text-white-50" to="/faqs">FAQs</Link>
                            <Link className="btn btn-link text-white-50" to="/services">Our Services</Link>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white mb-4">Companies</h5>
                            <Link className="btn btn-link text-white-50" to="/post">Post a Job</Link>
                            <Link className="btn btn-link text-white-50" to="/my">My Jobs</Link>
                            <Link className="btn btn-link text-white-50" to="/contact">Contact us</Link>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white mb-4">Job Seekers</h5>
                            <Link className="btn btn-link text-white-50" to="/jobs">Jobs</Link>
                            <Link className="btn btn-link text-white-50" to="/my-applied">My Applied Jobs</Link>
                            <Link className="btn btn-link text-white-50" to="/search?keyword=&category=&location=">Search Jobs</Link>
                            <Link className="btn btn-link text-white-50" to="/cv-manager">CV Manager</Link>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white mb-4">Contact</h5>
                            <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>{ contact.address }</p>
                            <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>{ contact.phone }</p>
                            <p className="mb-2"><i className="fa fa-envelope me-3"></i>{ contact.email }</p>
                            <div className="d-flex pt-2">
                                {/*<a className="btn btn-outline-light btn-social" href=""><i className="fab fa-twitter"></i></a>*/}
                                
                                <a className="btn btn-outline-light btn-social"
                                    href="https://web.facebook.com/ComputerProgrammingTutorial"
                                    target="_blank"><i className="fab fa-facebook-f"></i></a>

                                <a className="btn btn-outline-light btn-social"
                                    href="https://youtube.com/c/AdnanAfzal565"
                                    target="_blank"><i className="fab fa-youtube"></i></a>
                                
                                {/*<a className="btn btn-outline-light btn-social" href=""><i className="fab fa-linkedin-in"></i></a>*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                &copy; <a className="border-bottom" href="#">{ siteName }</a>, All Right Reserved. 
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <div className="footer-menu">
                                    <Link to="/">Home</Link>
                                    {/*<Link to="">FQAs</Link>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="chat-wrapper">

                { state.chats.map(function (chat, index) {
                    return (
                        <div className="chat-box" id={ `chat${ chat.id }` } key={ `chat-${ chat.id }` }>
                            <div className="chat-header" onClick={ function () {
                                toggleChat(chat.id);
                            } }>

                                <div>
                                    { chat.profileImage ? (
                                        <img src={ chat.profileImage }
                                            style={ styles.profileImage } />
                                    ) : (
                                        <img src={ imagePlaceholder }
                                            style={ styles.profileImage } />
                                    ) }

                                    { chat.name || "" }
                                </div>

                                <button className="close-btn" onClick={ function (event) {
                                    event.stopPropagation();
                                    closeChat(chat.id);
                                } }>×</button>
                            </div>

                            <div className="chat-body">

                                { chat.fetching && (
                                    <p>Loading...</p>
                                ) }

                                { chat.messages.map(function (message, index) {
                                    return (
                                        <div key={ `chat-${ chat.id }-message-${ message.id }` }
                                            className={ `message ${ message.sender_id == state.user?.id ? "self" : "other" }` }>
                                            { message.message }
                                        </div>
                                    );
                                }) }
                            </div>

                            <div className="chat-footer">
                                <input type="text" placeholder="Type a message"
                                    onKeyDown={ function (event) {
                                        handleSend(event, chat);
                                    } } />
                            </div>
                        </div>
                    );
                }) }
            </div>

            <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><i className="bi bi-arrow-up"></i></a>
        </>
    );
}

export default Footer;